import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { Helpers } from "./helpers";
import { AuthenticationService } from "./authentication.service"
import Swal from 'sweetalert2';
import { session } from '../environments/environment.session'
import { en as enk } from '../environments/environments.k'
import { en } from '../environments/environment.tok'
import * as CryptoJS from 'crypto-js';
import { interval, Subscription } from 'rxjs';
import { SpinnerService } from './shared/spinner.service'
import { Utf8EncodingService } from './md/service/utf8-encoding.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { MainService as MainServiceADMIN } from './admin/service/main.service';
import { MainService } from 'src/app/portal/service/main.service';
@Component({
	selector: 'body',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
	title = 'app';
	erpUser: any = undefined
	private subscription!: Subscription;
	sp: any = false
	cpatToken: any;
	AllAccountData: any = [];
	token: any;
	b_account_id: any;
	login: any;
	assigned_User_Roles: any = [];
	assigned_User_Roles_Name: any = [];
	AllUserRole: any = [];
	login_obj: any = {};
	@HostListener('mousemove', ['$event'])
	onMouseMove(event: MouseEvent): void {
		this.network()
	}

	@HostListener('window:scroll', [])
	onScroll() {
		this.showButton = window.scrollY > 300;
	}

	scrollToTop() {
		//   window.scrollTo({ top: 0, behavior: 'smooth' });
		const duration = 1000; // scroll duration in ms (1000 = 1s, increase for slower)
		const start = window.scrollY;
		const startTime = performance.now();

		const animateScroll = (currentTime: number) => {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1);

			// easeOutCubic for smooth feel
			const ease = 1 - Math.pow(1 - progress, 3);

			window.scrollTo(0, start * (1 - ease));

			if (progress < 1) {
				requestAnimationFrame(animateScroll);
			}
		};

		requestAnimationFrame(animateScroll);
	}

	intervalId: any;
	showButton = false;

	network() {
		if (!navigator.onLine) {
			this.sp = true
			this.tsppinner.show('opps !! Network Issue', 'Check the internet')
		}
		if (navigator.onLine && this.sp) {
			this.tsppinner.hide()
			if (this.subscription) {
				this.subscription.unsubscribe();
			}
			this.sp = false
		}

		if (!navigator.onLine) {
			this.check()
		}
	}


	check() {
		this.subscription = interval(1000) // 15 seconds in milliseconds
			.subscribe(() => {
				if (this.subscription) {
					this.subscription.unsubscribe();
				}
				this.network();
			});
	}

	constructor(
		private _router: Router,
		private AuthenticationService: AuthenticationService,
		private tsppinner: SpinnerService,
		private spinner: NgxSpinnerService,
		private utf8EncodingService: Utf8EncodingService,
		private route: ActivatedRoute,
		public mainServiceADMIN: MainServiceADMIN,
		private mainService: MainService,
	) {
		try {
			this.erpUser = JSON.parse(sessionStorage.getItem('1001') as any);
		} catch (err) {
			sessionStorage.clear();
			// this._router.navigate(['./index']);
			return;
		}

	}



	async ngOnInit() {
		this.startIdleWatcher();
		en.temppu = await this.decryptUsingAES256(en.temppu);
		en.temppa = await this.decryptUsingAES256(en.temppa);

		const urlParams = new URLSearchParams(window.location.search);
		const urlCpatToken = urlParams.get('cpat');
		let isCpatLogin = false;
		let cpatJson: string = '';

		if (urlCpatToken) {
			const rawCpat = urlCpatToken;
			const urlDecoded = decodeURIComponent(rawCpat);
			try {
				cpatJson = atob(urlDecoded);
				isCpatLogin = true;
			} catch (e) {
				console.error('CPAT is not valid base64', e);
			}
		}

		Helpers.setLoading(false);
		await this.getserver();
		if (this.severListen) {
			this.gon = true
			this._router.navigate(['/error']);
			return;
		}

		this.getAllLabel();
		this.getSystemModule();
		this.getAllLanguage();
		this._router.events.subscribe((route) => {
			if (route instanceof NavigationStart) {
				this.spinner.show();
				Helpers.bodyClass('fixed-navbar');
			}
			if (route instanceof NavigationEnd) {
				window.scrollTo(0, 0);
				this.spinner.hide();
				if (route.url == '/login' && (sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null)) {
					this._router.navigate(['/login']);
				}
			}
			// Hide spinner on navigation failure so it never gets permanently stuck
			if (route instanceof NavigationError || route instanceof NavigationCancel) {
				this.spinner.hide();
			}
		});
		console.log(cpatJson)
		if (isCpatLogin) {
			await this.sendTokenToBackend(JSON.parse(cpatJson));
			this.removeTokenFromUrl();
			return;
		}

		if (sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null) {
			this.gon = true
			this._router.navigate(['/login'])
		} else {
			this.gon = false
			await this.getErpUser()

			if (this.erpUser['b_acct_id'] == 0) {
				this._router.navigate(['./solution-admin/index']);
			} else {
				if (this.erpUser['role_cd'].includes('DIRECTOR') || this.erpUser['role_cd'].includes('Dir')) {
					this._router.navigate(['./file-o0verView']);
				} else {
					// this._router.navigate(['/index']);
					this._router.navigate(['/acms/acms-index']);
				}
			}
		}

		Helpers.setLoading(false);

	}



	decryptUsingAES256(text: any) {
		let _key = CryptoJS.enc.Utf8.parse(enk.jumpOT);
		let _iv = CryptoJS.enc.Utf8.parse(enk.jumpOT);
		let decrypted = CryptoJS.AES.decrypt(
			text, _key, {
			keySize: 16,
			iv: _iv,
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		}).toString(CryptoJS.enc.Utf8);
		return decrypted;
	}

	gon: boolean = true
	async getErpUser() {
		let obj = {}
		let resp = await this.AuthenticationService.getErpUser((obj))
		if (resp['error'] == false) {
			// Handle legacy double-encoded erpUser: JSON.stringify was previously applied to a JSON string,
			// causing the DB to store '"jsonString"' instead of 'jsonString'.
			// Detect that case and unwrap it.
			let rawErpUser: string = resp['data'][0]['erpUser'];
			let erpUserStr: string = rawErpUser;
			try {
				const parsed = JSON.parse(rawErpUser);
				if (typeof parsed === 'string') {
					erpUserStr = parsed; // was double-encoded; unwrap one level
				}
			} catch { /* keep erpUserStr as rawErpUser */ }
			this.erpUser = JSON.parse(erpUserStr);

			this.gon = true
			session.erpUser = this.utf8EncodingService.encodeToUtf8(erpUserStr)
		} else {
			Swal.fire('Error', resp['data'], 'error')
		}
	}

	allLanguage = []
	async getAllLanguage() {
		var obj = new Object();
		var resp = await this.AuthenticationService.getAllLanguages(JSON.stringify(obj));
		if (resp['error'] == false) {
			this.AuthenticationService.allLanguage = resp.data;
			this.AuthenticationService.language_cd = resp.data[0]['language_cd']
		} else {

		}
	}

	async getSystemModule() {
		let obj: any = new Object();
		obj['b_acct_id'] = 0;
		var resp = await this.AuthenticationService.getModules(JSON.stringify(obj));
		if (resp['error'] == false) {
			obj = new Object();
			for (let i = 0; i < resp.data.length; i++) {
				obj[resp.data[i]['module_cd']] = resp.data[i]['module_name']
			}
			this.AuthenticationService.allSystemModuleObj = obj;

		} else {

		}
	}
	severListen: any = false;
	async getserver() {
		var resp = await this.AuthenticationService.getserver(JSON.stringify({}));
		if (resp['error']) {
			this.severListen = resp['error']
			this._router.navigate(['/error']);
		}
	}


	allLabel = []
	async getAllLabel() {
		var obj: any = new Object();
		obj['module_cd'] = ["COMMON", "MD"]
		var resp = await this.AuthenticationService.getcomponentLabelvalueswithLanguage(JSON.stringify(obj));
		if (resp['error'] == false) {
			this.AuthenticationService.allLabel = resp.data;
			let obj: any = new Object();
			for (let i = 0; i < resp.data.length; i++) {
				obj[resp.data[i]['language_cd'] + resp.data[i]['component_cd'] + resp.data[i]['label_no']] = resp.data[i]['value_to_show'];
			}
			this.AuthenticationService.allLableShowObj = obj;

		} else {

		}
	}

	/********************************************** auto logout code start ************************************************ */
	// Efficient idle detection: update a timestamp on activity, check it on a single interval.
	// Avoids creating/destroying hundreds of timers per second on mousemove.
	private readonly IDLE_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
	private readonly IDLE_CHECK_INTERVAL_MS = 60 * 1000; // check every 1 minute
	private lastActivityTime = Date.now();
	private idleCheckInterval: any;

	@HostListener('document:mousemove') onIdleMouseMove() { this.lastActivityTime = Date.now(); }
	@HostListener('document:keydown')   onKeyDown()      { this.lastActivityTime = Date.now(); }
	@HostListener('document:click')     onClick()        { this.lastActivityTime = Date.now(); }
	@HostListener('document:touchstart') onTouch()       { this.lastActivityTime = Date.now(); }

	startIdleWatcher() {
		this.idleCheckInterval = setInterval(async () => {
			if (Date.now() - this.lastActivityTime >= this.IDLE_TIMEOUT_MS) {
				clearInterval(this.idleCheckInterval);
				await this.logOut();
			}
		}, this.IDLE_CHECK_INTERVAL_MS);
	}

	async logOut() {
		if (window.location.hash != '#/login' && !this.AuthenticationService.uiHost.startsWith('localhost')
			&& !this.AuthenticationService.uiHost.startsWith('tracking.upda.co.in')) {
			Swal.fire('opps..', 'Your session is expired please login again', 'info')
			sessionStorage.removeItem('1000')
			sessionStorage.removeItem('1001')
			sessionStorage.removeItem('_rt')
			session.erpUser = {}
			this._router.navigate(['/login']);
		}
	}


	async sendTokenToBackend(token: any) {
		this.tsppinner.show('', '');
		try {
			let resp = await this.AuthenticationService.sendCpatTokenToBackend(token);
			if (resp['error'] == false && resp['data']?.length > 0) {
				/**
				 * Backend returns the same format as the normal login route:
				 *   { error: false, data: [userRecord], token: 'jwt...', gateway_id: '...' }
				 * The userRecord includes darpan_access { l1, l2, projcode }
				 */
				this.AllAccountData = JSON.parse(resp['data']);
				this.token = resp['token'];

				// Store gateway_id in session (matches login flow pattern)
				sessionStorage.setItem('1001', resp['gateway_id']);
				sessionStorage.setItem('1000', resp['token']);
				if (resp['refreshToken']) sessionStorage.setItem('_rt', resp['refreshToken']);

				// Store DARPAN access levels for data filtering
				if (resp['data'][0]?.darpan_access) {
					sessionStorage.setItem('darpan_access', JSON.stringify(resp['data'][0].darpan_access));
				}

				// Follow the same login flow → submitAccount → getUserRoleInfo → finalSubmit → dashboard
				let s = JSON.parse(resp['data'])
				this.b_account_id = s[0]['b_acct_id'];
				await this.submitAccount();
			} else {
				this.tsppinner.hide();
				const errMsg = typeof resp['data'] === 'string' ? resp['data'] : 'DARPAN authentication failed';
				Swal.fire('Error', errMsg, 'error');
			}
		} catch (err: any) {
			this.tsppinner.hide();
			console.error('[CPAT] sendTokenToBackend error:', err);
			let errorMsg = 'Unable to validate DARPAN token. Please try again.';
			if (err && err.error && err.error.data) {
				try {
					errorMsg = JSON.parse(err.error.data);
				} catch (e) {
					errorMsg = err.error.data;
				}
			}
			Swal.fire('Error', errorMsg, 'error');
		}
	}

	async submitAccount() {
		if (this.b_account_id == undefined || this.b_account_id == null) {
			this.tsppinner.hide()
			Swal.fire('Error...', 'Login Failed!', 'error')
			return;
		}

		for (let i = 0; i < this.AllAccountData.length; i++) {
			if (this.AllAccountData[i]['b_acct_id'] == this.b_account_id) {
				this.login = this.AllAccountData[i];
			}
		}
		let user_id = ''
		const characters = '58974259988174808546';
		for (let i = 0; i < 19; i++) {
			const randomIndex = Math.floor(Math.random() * characters.length);
			user_id += characters[randomIndex];
		}
		sessionStorage.setItem('1005', `${user_id.substring(0, 9)}${this.login['b_acct_id']}${user_id.substring(10, 19)}`);
		this.login['assigned_product_cd'] = await this.getAccountModule(this.login['b_acct_id']);
		this.login['user_id'] = this.login['le_id'];
		await this.getUserRoleInfo(this.login);
	}

	async getAccountModule(b_acct_id: any) {
		var obj: any = new Object();
		obj['b_acct_id'] = b_acct_id;
		var resp: any = await this.AuthenticationService.getaccountmodule(JSON.stringify(obj));
		if (resp['error'] == false) {
			return resp['data'][0]['module_cd'].split(",");
		} else {
			this.tsppinner.hide()
		}
		return []
	}

	async getUserRoleInfo(acct_info: any) {
		this.assigned_User_Roles = []
		this.assigned_User_Roles_Name = []
		var obj1: any = new Object();
		obj1['user_id'] = acct_info.user_id;
		obj1['b_acct_id'] = acct_info.b_acct_id;
		var resp;
		if (acct_info.b_acct_id == 0) {
			resp = await this.AuthenticationService.getCurrentUserFromAdmin(JSON.stringify(obj1));
		} else {
			resp = await this.AuthenticationService.getCurrentUserFromMD(JSON.stringify(obj1));
		}
		if (resp['error'] == false) {
			this.AllUserRole = resp.data;
			for (let i = 0; i < this.AllUserRole.length; i++) {
				this.assigned_User_Roles.push(this.AllUserRole[i]['role_cd']);
				this.assigned_User_Roles_Name.push(this.AllUserRole[i]['role_name']);
			}
			await this.finalSubmit();
		} else {
			this.tsppinner.hide()
		}
	}

	async finalSubmit() {
		this.login['role_cd'] = this.assigned_User_Roles;
		this.login['role_name'] = this.assigned_User_Roles_Name;
		this.login['party_name'] = await this.getSetPartyName(this.login['b_acct_id'], this.login['contact_email'], this.login['phone_no'])
		let obj: any = {}
		obj['erpUser'] = JSON.stringify(this.login)
		let resp = await this.AuthenticationService.updateSession(obj)
		if (resp['error'] == false) {
			session.erpUser = {}
			session.erpUser = this.utf8EncodingService.encodeToUtf8(JSON.stringify(this.login))
			sessionStorage.setItem('1000', this.token);
			if (sessionStorage.getItem('_rt') === null && this.login?.refreshToken) sessionStorage.setItem('_rt', this.login.refreshToken);
			this.login_obj['status'] = "PASS";
			this.login_obj['user_id'] = "User ID:" + this.login['le_id'] + " & In Account Id:" + this.login['b_acct_id'];

			this.tsppinner.hide()
			Swal.fire('Success...', 'Login Successful', 'success');
			// if (this.login['b_acct_id'] == 0) {
			// 	this._router.navigate(["/solution-admin/index"])
			// } else {
			// 	if (this.login['role_cd'].includes('DIRECTOR') || this.login['role_cd'].includes('Dir')) {
			// 		this._router.navigate(['./file-overView']);
			// 	} else {
			this._router.navigate(['/acms/acms-index']);
			// this._router.navigate(['/acms/dp-show/pushed-data']);
			// }
			await this.insertLoginInfo(this.login_obj);
			// }
		} else {
			this.tsppinner.hide()
			Swal.fire('Oops!!', resp['data'], 'error')
		}
	}

	async getSetPartyName(b_acct_id: any, email: any, phone_no: any) {
		let obj: any = {}
		obj['b_acct_id'] = b_acct_id
		obj['contact_email'] = email
		obj['phone_no'] = phone_no
		var resp = await this.mainServiceADMIN.getCurrentLegalEntity(JSON.stringify(obj));
		if (resp['error'] == false) {
			return resp['data'][0]['party_name'];
		} else {
			return 'NA'
		}
	}

	async insertLoginInfo(obj: any) {
		await this.AuthenticationService.createloginInfo(JSON.stringify(obj));
	}

	removeTokenFromUrl() {
		window.history.replaceState({}, document.title, window.location.pathname);
	}
	/********************************************** auto logout code end *****************************************************/
}
